const useProductRegistrationPersonalInformation = async () => {
  const { getLabels, getLabelByPath } = useCommonLabels();
  const { mgnlContentPath } = useMagnoliaContent();

  const personalInformationLabels = getLabels("/BWF/shop/shared/addressForm/", [
    "chooseSalutationLabel",
    "firstNameLabel",
    "firstNamePlaceholder",
    "lastNameLabel",
    "lastNamePlaceholder",
    "streetAndHouseNoLabel",
    "streetAndHouseNoPlaceholder",
    "postalCodeLabel",
    "postalCodePlaceholder",
    "cityLabel",
    "cityPlaceholder",
    "addressSuffixLabel",
    "addressSuffixPlaceholder",
    "countryLabel",
    "eMailAddressLabel",
    "eMailAddressPlaceholder",
  ]);

  const {
    firstNameValidators,
    lastNameValidators,
    emailValidators,
    streetNumberValidators,
    addressAdditionalValidators,
    cityValidators,
    zipCodeValidators,
    requiredValidator,
  } = await useValidation();

  const salutationLabels = getLabels("/BWF/form/shared/salutations/", [
    "not_specified",
    "mr",
    "mrs",
    "diverse",
  ]);
  const selectableSalutations = [
    ...(Object.entries(salutationLabels ?? {})?.map(([key, value]) => ({
      value: key,
      label: value,
    })) ?? []),
  ];
  // registration is expected only from the active Market Country, so it is decided to only deliver the country from the content path root.
  const currentCountry = mgnlContentPath.value.split("/")[1];
  const countryLabel = getLabelByPath(`/BWF/form/shared/country/${currentCountry}`);
  const selectableCountries = [
    {
      value: currentCountry,
      label: countryLabel,
    },
  ];

  const productRegistrationPersonalInformationRules = computed(() => ({
    salutation: {
      ...requiredValidator,
    },
    firstName: {
      ...requiredValidator,
      ...firstNameValidators,
    },
    lastName: {
      ...requiredValidator,
      ...lastNameValidators,
    },
    email: {
      ...requiredValidator,
      ...emailValidators,
    },
    street: {
      ...streetNumberValidators,
    },
    postalCode: {
      ...zipCodeValidators,
    },
    city: {
      ...cityValidators,
    },
    additionalAddressLine1: {
      ...addressAdditionalValidators,
    },
  }));

  const { azureUser } = useAzureUser();
  const customerType = computed(() => {
    // 1 is logged in
    // 0 is guest
    return azureUser.value?.homeAccountId ? 1 : 0;
  });

  return {
    customerType,
    personalInformationLabels,
    selectableSalutations,
    selectableCountries,
    productRegistrationPersonalInformationRules,
  };
};

export default createSharedComposable(useProductRegistrationPersonalInformation);
